import { Star } from '~/core/shapes/Star';
var ParticleType;
(function (ParticleType) {
    ParticleType[ParticleType["Star"] = 0] = "Star";
})(ParticleType || (ParticleType = {}));
export class Particle {
    constructor(stage, x, y, radius, color, maxY, speedY, speedX, rotationSpeed, particleType = ParticleType.Star) {
        this.isActive = true;
        this.stage = stage;
        this.shape = Particle.createParticleShape(particleType, x, y, radius, color);
        this.speedX = speedX;
        this.speedY = speedY;
        this.rotationSpeed = rotationSpeed;
        this.maxY = maxY;
    }
    static createParticleShape(type, x, y, size, color) {
        switch (type) {
            case ParticleType.Star:
                return new Star({
                    x,
                    y,
                    numPoints: 4,
                    innerRadius: size * 0.5,
                    outerRadius: size,
                    fill: color,
                    opacity: Math.random() * 0.4 + 0.6,
                });
        }
    }
    update() {
        if (!this.isActive)
            return;
        this.shape.x(this.shape.x() + this.speedX);
        this.shape.y(this.shape.y() + this.speedY);
        this.shape.rotation(this.shape.rotation() + this.rotationSpeed);
        if (this.shape.y() > this.maxY) {
            this.reset();
        }
    }
    reset() {
        var _a;
        const verticalSize = this.shape.height();
        const randomYOffset = Math.random() * 100;
        this.shape.y(-(verticalSize + randomYOffset));
        const distributionWidth = ((_a = this.stage) === null || _a === void 0 ? void 0 : _a.width()) || this.maxY * 1.5;
        this.shape.x(Math.random() * distributionWidth);
    }
    remove() {
        this.isActive = false;
        this.shape.remove();
    }
}
